import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import type { Investigation } from '@/types/data'
import http from '@/lib/http'
import { useLockItemById } from '@/services/useLockItem'
import usePrepareNextRequest from './usePrepareNextRequest'
import { shouldLockInvestigation } from '@/lib/permissions'

export const useCurrentInvestigation = (enabled = true) => {
  const { id } = useParams<{ id: string }>()

  if (!id) {
    throw new Error('No ID provided')
  }

  const investigation = useQuery<Investigation>({
    queryKey: ['investigationRequestById', id],
    queryFn: async () => {
      return await http.get<Investigation, Investigation>('/prescriber/investigations', {
        params: {
          investigationId: id
        }
      })
    },
    staleTime: 0,
    refetchOnMount: true,
    enabled
  })

  const data = investigation?.data

  useLockItemById(data?.id ?? '', !!(data && !data?.locked && enabled && shouldLockInvestigation()), true)
  usePrepareNextRequest(enabled, true)

  return investigation
}
